import { animate, AnimationTriggerMetadata, AUTO_STYLE, state, style, transition, trigger } from '@angular/animations';

import { IAnimationOptions } from '../_interfaces/animate.interface';

const DEFAULT_DURATION = 500;
const DEFAULT_HEIGHT = '0rem';

export function expandCollapseAnimation(options?: IAnimationOptions): AnimationTriggerMetadata {
  return trigger((options && options.anchor) || 'expandCollapse', [
    state(
      '0',
      style({
        height: '0',
        visibility: 'hidden',
        overflow: 'hidden'
      })
    ),
    state(
      '0-partially-hidden',
      style({
        height: options.height || DEFAULT_HEIGHT,
        visibility: AUTO_STYLE,
        overflow: 'hidden'
      })
    ),
    state(
      '1',
      style({
        height: AUTO_STYLE,
        visibility: AUTO_STYLE,
        overflow: 'hidden'
      })
    ),
    state(
      '1-no-hidden',
      style({
        height: AUTO_STYLE,
        visibility: AUTO_STYLE,
        overflow: 'visible'
      })
    ),
    state(
      '1-auto',
      style({
        height: AUTO_STYLE,
        visibility: AUTO_STYLE,
        overflow: 'auto'
      })
    ),
    transition('0 => 1', [animate('{{durationIn}}ms {{delayIn}}ms')], {
      params: {
        delayIn: (options && options.delayIn) || 0,
        durationIn: (options && options.durationIn) || DEFAULT_DURATION
      }
    }),
    transition('1 => 0', [animate('{{durationOut}}ms {{delayOut}}ms')], {
      params: {
        delayOut: (options && options.delayOut) || 0,
        durationOut: (options && options.durationOut) || DEFAULT_DURATION
      }
    }),
    transition(
      '0 => 1-no-hidden',
      [animate('{{durationIn}}ms {{delayIn}}ms')],
      {
        params: {
          delayIn: (options && options.delayIn) || 0,
          durationIn: (options && options.durationIn) || DEFAULT_DURATION
        }
      }
    ),
    transition(
      '1-no-hidden => 0',
      [animate('{{durationOut}}ms {{delayOut}}ms')],
      {
        params: {
          delayOut: (options && options.delayOut) || 0,
          durationOut: (options && options.durationOut) || DEFAULT_DURATION
        }
      }
    ),
    transition('0 => 1-auto', [animate('{{durationIn}}ms {{delayIn}}ms')], {
      params: {
        delayIn: (options && options.delayIn) || 0,
        durationIn: (options && options.durationIn) || DEFAULT_DURATION
      }
    }),
    transition('1-auto => 0', [animate('{{durationOut}}ms {{delayOut}}ms')], {
      params: {
        delayOut: (options && options.delayOut) || 0,
        durationOut: (options && options.durationOut) || DEFAULT_DURATION
      }
    }),
    transition(
      '0-partially-hidden => 1',
      [animate('{{durationOut}}ms {{delayOut}}ms')],
      {
        params: {
          delayOut: (options && options.delayOut) || 0,
          durationOut: (options && options.durationOut) || DEFAULT_DURATION
        }
      }
    ),
    transition(
      '1 => 0-partially-hidden',
      [animate('{{durationOut}}ms {{delayOut}}ms')],
      {
        params: {
          delayOut: (options && options.delayOut) || 0,
          durationOut: (options && options.durationOut) || DEFAULT_DURATION
        }
      }
    )
  ]);
}

export function expandCollapseHorizontallyAnimation(options?: IAnimationOptions): AnimationTriggerMetadata {
  return trigger((options && options.anchor) || 'expandCollapseHorizontally', [
    state(
      '0',
      style({
        width: '0',
        visibility: 'hidden',
        overflow: 'hidden'
      })
    ),
    state(
      '1',
      style({
        width: '100%',
        visibility: AUTO_STYLE,
        overflow: 'hidden'
      })
    ),
    state(
      '1-no-hidden',
      style({
        width: '100%',
        visibility: AUTO_STYLE,
        overflow: 'visible'
      })
    ),
    transition('0 => 1', [animate('{{durationIn}}ms {{delayIn}}ms')], {
      params: {
        delayIn: (options && options.delayIn) || 0,
        durationIn: (options && options.durationIn) || DEFAULT_DURATION
      }
    }),
    transition('1 => 0', [animate('{{durationOut}}ms {{delayOut}}ms')], {
      params: {
        delayOut: (options && options.delayOut) || 0,
        durationOut: (options && options.durationOut) || DEFAULT_DURATION
      }
    }),
    transition(
      '0 => 1-no-hidden',
      [animate('{{durationIn}}ms {{delayIn}}ms')],
      {
        params: {
          delayIn: (options && options.delayIn) || 0,
          durationIn: (options && options.durationIn) || DEFAULT_DURATION
        }
      }
    ),
    transition(
      '1-no-hidden => 0',
      [animate('{{durationOut}}ms {{delayOut}}ms')],
      {
        params: {
          delayOut: (options && options.delayOut) || 0,
          durationOut: (options && options.durationOut) || DEFAULT_DURATION
        }
      }
    )
  ]);
}
